var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[_c('div',{staticClass:"flex flex-col lg:flex-row"},[_c('div',{staticClass:"flex-1 mb-4"},[_vm._t("title")],2),_c('div',{staticClass:"flex flex-col lg:flex-row"},[_vm._t("actions")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }